var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.5 19.5",
    style: {
      enableBackground: "new 0 0 19.5 19.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.groups-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M7.3,8.8h4.8c0.4,0,0.7-0.3,0.6-0.6c-0.2-0.9-0.9-2.4-3-2.4c-2.1,0-2.8,1.5-3,2.4C6.7,8.5,7,8.8,7.3,8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M1.3,18.8h4.8c0.4,0,0.7-0.3,0.6-0.6c-0.2-0.9-0.9-2.4-3-2.4c-2.1,0-2.8,1.5-3,2.4C0.7,18.5,1,18.8,1.3,18.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M13.3,18.8h4.8c0.4,0,0.7-0.3,0.6-0.6c-0.2-0.9-0.9-2.4-3-2.4s-2.8,1.5-3,2.4C12.7,18.5,13,18.8,13.3,18.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M3.8,13.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5S2.9,13.8,3.8,13.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M9.8,3.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5S8.3,1.4,8.3,2.2S8.9,3.8,9.8,3.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "groups-svg",
    d: "M15.8,13.8c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5S14.9,13.8,15.8,13.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.7d0a0dddc7ef6e6587a7ce74e3cc97e2.svg";
export { ForwardRef as ReactComponent };